import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type BeneficiaryUpdatedToastProps = {
  toastId: string | number;
};

export const BeneficiaryUpdatedToast: FC<BeneficiaryUpdatedToastProps> = ({toastId}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('view.beneficiaries.updatedToast.title')}
      description={t('view.beneficiaries.updatedToast.description')}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.beneficiaries.toastClose')}
    />
  );
};

export function showBeneficiaryUpdatedToast(): void {
  toast.custom(id => <BeneficiaryUpdatedToast toastId={id} />, {duration: 10_000});
}
